import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const FeedContainer = styled.div`
  background: #2c3e50;
  border-radius: 8px;
  padding: 16px;
  max-height: 300px;
  overflow-y: auto;
  font-family: 'Courier New', monospace;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(79, 172, 254, 0.3);
    border-radius: 3px;
    
    &:hover {
      background: rgba(79, 172, 254, 0.5);
    }
  }
`;

const FeedItem = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #ecf0f1;
  
  &.info { color: #3498db; }
  &.success { color: #2ecc71; }
  &.warning { color: #f39c12; }
  &.error { color: #e74c3c; }
`;

const Timestamp = styled.span`
  color: #95a5a6;
  min-width: 80px;
`;

const Message = styled.span`
  flex: 1;
`;

const StatusBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #34495e;
  border-radius: 4px;
  color: #ecf0f1;
  font-size: 12px;
`;

const LiveDataFeed = ({ isLive = true }) => {
  const [feedItems, setFeedItems] = useState([
    {
      id: 1,
      timestamp: new Date(),
      type: 'success',
      message: 'Blockchain sync completed'
    },
    {
      id: 2,
      timestamp: new Date(Date.now() - 5000),
      type: 'info',
      message: 'New inventory item added: GOLD-004'
    },
    {
      id: 3,
      timestamp: new Date(Date.now() - 10000),
      type: 'success',
      message: 'Token minting completed: 1000 PING'
    }
  ]);

  useEffect(() => {
    if (!isLive) return;

    const interval = setInterval(() => {
      const messages = [
        { type: 'info', message: 'Network status check completed' },
        { type: 'success', message: 'Transaction confirmed on blockchain' },
        { type: 'info', message: 'Inventory sync in progress' },
        { type: 'success', message: 'Quality verification passed' },
        { type: 'warning', message: 'Network latency increased' },
        { type: 'info', message: 'New peer connected to network' },
        { type: 'success', message: 'Deposit operation completed' }
      ];

      const randomMessage = messages[Math.floor(Math.random() * messages.length)];
      
      setFeedItems(prev => [
        {
          id: Date.now(),
          timestamp: new Date(),
          ...randomMessage
        },
        ...prev.slice(0, 19) // Keep only last 20 items
      ]);
    }, 3000);

    return () => clearInterval(interval);
  }, [isLive]);

  const formatTime = (timestamp) => {
    return timestamp.toLocaleTimeString('en-US', { 
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <Container>
      <StatusBar>
        <div>
          {isLive ? (
            <>
              <span style={{ color: '#2ecc71' }}>●</span> LIVE
            </>
          ) : (
            <>
              <span style={{ color: '#e74c3c' }}>●</span> PAUSED
            </>
          )}
        </div>
        <div>{feedItems.length} events</div>
      </StatusBar>
      
      <FeedContainer>
        {feedItems.map(item => (
          <FeedItem key={item.id} className={item.type}>
            <Timestamp>
              {formatTime(item.timestamp)}
            </Timestamp>
            <Message>
              {item.message}
            </Message>
          </FeedItem>
        ))}
      </FeedContainer>
    </Container>
  );
};

export default LiveDataFeed; 